import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { IApiCommentableType, IApiInvestigation } from 'src/app/shared/modules/graphql/types/types';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';
import { GqlCommentService } from 'src/app/shared/modules/graphql/services';
import { investigationAdminCommentsCreate } from "src/app/shared/helpers/auth-config/investigations.config";

@Component({
  selector: 'app-add-comment-table-modal',
  templateUrl: './add-comment-table-modal.component.html',
  styleUrls: ['./add-comment-table-modal.component.scss']
})
export class AddCommentTableModalComponent extends DialogContentBase {

  @ViewChild('commentForm', { static: false }) commentForm: NgForm;
  @Input() data: IApiInvestigation;
  public comment = "";
  public adminOnly = false;
  
  public authConfig = {
    investigationAdminCommentsCreate
  };

  constructor(
    public dialog: DialogRef,
    private loaderService: LoaderService,
    private commentService: GqlCommentService,
    private notifications: NotificationsService
  ) {
    super(dialog);
  }

  public close(result = false) {
    this.dialog.close(result);
  }

  addComment() {
    if (this.commentForm?.invalid) {
      this.commentForm.form.markAllAsTouched();
      return;
    }

    this.loaderService
      .show$(
        this.commentService.addComment({ 
          commentableId: this.data.id, 
          commentableType: IApiCommentableType.Investigation, 
          text: this.comment, 
          adminOnly: this.adminOnly 
        }).pipe(
          this.notifications.snackbarErrorPipe(),
          this.notifications.snackbarPipe("Comment added successfully"),
        )
      )
      .subscribe(() => {
        this.close(true);
      });
  }
}
